import React, { Component } from 'react';
import Moment from 'moment';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import ArchiveIcon from '@material-ui/icons/Archive';
import { withStyles } from '@material-ui/core/styles';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { withSnackbar } from 'notistack';
// import { enqueueSnackbar } from 'notistack';
import TabPanel from '../../components/TabPanel';
import AppointmentRequestViewModal from './components/AppointmentRequestViewModal';
import CurrentUserContext from '../../contexts/CurrentUserContext';
import { CurrentPracticeConsumer } from '../../contexts/CurrentPracticeContext';
import * as api from '../../services/api/admin';
import './style.css';

// const FROM_PROVIDERS_TAB = 0;
// const FROM_QWELL_SEARCH_TAB = 1;
// const ARCHIVED_TAB = 2;

const FROM_QWELL_SEARCH_TAB = 0;
const ARCHIVED_TAB = 1;

class ProviderAdminReferrals extends Component {
  state = {
    activeProvider: {},
    appointmentRequests: [],
    tabPosition: 0,
    isLoading: true,
    requestUnderEdit: {},
    openAppointmentRequestModal: false,
    pageIndex: 0,
    pageLimit: 20,
    appointmentData: [],
    flag: false,
  };

  async componentDidMount() {
    const { activeProvider } = this.context;
    const { tabPosition } = this.state;
    return this.fetchAppointmentRequests(activeProvider, tabPosition);
  }

  fetchAppointmentRequests = async (provider, tabPosition) => {
    const { enqueueSnackbar } = this.props;
    const { pageIndex, flag } = this.state;
    if (!flag) {
      this.setState({ isLoading: true });
    }

    try {
      let appointmentRequests = [];

      if (tabPosition === FROM_QWELL_SEARCH_TAB) {
        appointmentRequests = await api.fetchAppointmentRequests({
          providerId: provider.id,
          fromSearch: true,
          offset: pageIndex,
        });
      } else if (tabPosition === ARCHIVED_TAB) {
        appointmentRequests = await api.fetchAppointmentRequests({
          providerId: provider.id,
          archived: true,
          offset: pageIndex,
        });
      }

      // Reset State Before Updating**
      this.setState({
        appointmentData: [],  // Reset previous data
        appointmentRequests: [],  // Reset previous requests
      });

      // Set New Data in a Single setState()**
      this.setState({
        appointmentData: appointmentRequests, // Set fresh data
        appointmentRequests,  // Set fresh requests
        activeProvider: provider,
        tabPosition,
      });
    } catch (err) {
      console.log(err);
      enqueueSnackbar('Fetching appointment requests failed. Please try again.');
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleTabPositionChange = (event, newTabPosition) => {
    this.setState({ pageIndex: 0, appointmentData: [], flag: false }, () => {
      const { activeProvider } = this.state;
      this.fetchAppointmentRequests(activeProvider, newTabPosition);
    });
    // this.setState({ pageIndex: 0 }, () => {
    //   const { activeProvider } = this.state;
    //   this.fetchAppointmentRequests(activeProvider, newTabPosition);
    // })
  };

  // onPageForward = async () => {
  //   //this won't cover the case where the total num of consult notes % PAGE_LIMIT = 0. But it's a quick fix for now.
  //   const { tabPosition, activeProvider } = this.state;
  //   if (this.state.appointmentRequests.length < this.state.pageLimit) {
  //     enqueueSnackbar('You are on the last page');
  //   }
  //   else {
  //     this.setState({ pageIndex: this.state.pageIndex + 1 }, () => {
  //       this.fetchAppointmentRequests(
  //         activeProvider,
  //         tabPosition
  //       );
  //     });
  //   }
  // };

  // onPageBack = async () => {
  //   const { tabPosition, activeProvider } = this.state;
  //   if (this.state.pageIndex === 0) {
  //     enqueueSnackbar('You are on the first page');
  //   }
  //   else {
  //     this.setState({ pageIndex: this.state.pageIndex - 1 }, () => {
  //       this.fetchAppointmentRequests(
  //         activeProvider,
  //         tabPosition
  //       );

  //     });
  //   }
  // };

  onProviderChange = async (providerId, practice) => {
    const { tabPosition } = this.state;
    const providers = practice.providers;
    const provider = providers.find(provider => provider.id === providerId);
    return this.fetchAppointmentRequests(provider, tabPosition);
  };

  onViewAppointmentRequest = request => {
    this.setState({
      requestUnderEdit: request,
      openAppointmentRequestModal: true,
    });
  };

  onArchiveAppointmentRequest = async request => {
    const { enqueueSnackbar } = this.props;
    const { activeProvider, tabPosition } = this.state;
    try {
      await api.archiveAppointmentRequest(request.id);
    } catch (err) {
      enqueueSnackbar(
        'Failed to archive appointment request. Please try again.'
      );
    } finally {
      await this.fetchAppointmentRequests(activeProvider, tabPosition);
    }
  };

  onCloseModal = () => {
    this.setState({
      requestUnderEdit: {},
      openAppointmentRequestModal: false,
    });
  };

  showMore = () => {
    const { tabPosition, activeProvider, flag } = this.state;
    this.setState({ flag: true, pageIndex: this.state.pageIndex + 20 }, () => {
      this.fetchAppointmentRequests(activeProvider, tabPosition);
    });
  };

  render() {
    const {
      appointmentRequests,
      activeProvider,
      tabPosition,
      isLoading,
      openAppointmentRequestModal,
      requestUnderEdit,
      pageIndex,
      pageLimit,
      appointmentData,
    } = this.state;
    const { classes } = this.props;

    const mergedAppointmentRequest = [].concat.apply([], appointmentData);

    return (
      <CurrentPracticeConsumer>
        {({ currentPractice }) => (
          <>
            <div className={classes.mainWrapper}>
              <div className={classes.main}>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  classes={{ container: classes.header }}
                >
                  <Grid item xs={12} md={6} className="headerFont">
                    <Typography variant="h2" className={classes.headerText}>
                      Requested Appointments
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={6} classes={{ item: classes.actions }}>
                    <Select
                      value={activeProvider.id || ''}
                      onChange={event =>
                        this.onProviderChange(
                          event.target.value,
                          currentPractice
                        )
                      }
                    >
                      {(currentPractice.providers || []).map(provider => {
                        return (
                          <MenuItem style={{whiteSpace:"normal",fontSize:"small"}} value={provider.id} key={provider.id}>
                            {provider.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </Grid>
                </Grid>

                <AppBar
                  position="static"
                  color="default"
                  classes={{ root: classes.appBar }}
                >
                  <Tabs
                    value={tabPosition}
                    onChange={this.handleTabPositionChange}
                  >
                    {/* <Tab label="From Other Providers" /> */}
                    <Tab label="From Qwell Search" />
                    <Tab label="Archived" />
                  </Tabs>
                </AppBar>

                <TabPanel className="overflowScroll">
                  {isLoading ? (
                    <div className={classes.loading}>
                      <CircularProgress />
                    </div>
                  ) : (
                    <Grid item xs={12}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Patient</TableCell>
                            <TableCell>Requested By</TableCell>
                            <TableCell>Requested At</TableCell>
                            <TableCell />
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {mergedAppointmentRequest.map(request => (
                            <TableRow key={request.id}>
                              <TableCell width="250">
                                {request.patient.name}
                              </TableCell>
                              <TableCell width={request.sender ? '350' : '200'}>
                                {request.sender.name ? (
                                  <span>{request.sender.name}</span>
                                ) : (
                                  <span>Qwell Search</span>
                                )}
                              </TableCell>
                              <TableCell width="200">
                                {Moment(request.createdAt).format(
                                  'MM/DD/YYYY hh:mma'
                                )}
                              </TableCell>
                              <TableCell>
                                <IconButton
                                  onClick={() =>
                                    this.onViewAppointmentRequest(request)
                                  }
                                >
                                  <RemoveRedEyeIcon />
                                </IconButton>

                                {/* {(tabPosition === FROM_QWELL_SEARCH_TAB ||
                                    tabPosition === FROM_PROVIDERS_TAB) && (
                                      <IconButton
                                        onClick={() =>
                                          this.onArchiveAppointmentRequest(request)
                                        }
                                      >
                                        <ArchiveIcon />
                                      </IconButton>
                                    )} */}
                                {tabPosition === FROM_QWELL_SEARCH_TAB && (
                                  <IconButton
                                    onClick={() =>
                                      this.onArchiveAppointmentRequest(request)
                                    }
                                  >
                                    <ArchiveIcon />
                                  </IconButton>
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      {/* <div className={classes.pageTurners}  >
                          <IconButton disabled={pageIndex === 0}>
                            <ArrowBackIosIcon
                              style={{ opacity: pageIndex === 0 ? '0.5' : '1.0' }}
                              color="primary"
                              variant="contained"
                              onClick={() => this.onPageBack()}
                            />
                          </IconButton>
                          <IconButton disabled={appointmentRequests.length < pageLimit}>
                            <ArrowForwardIosIcon
                              style={{ opacity: appointmentRequests.length < pageLimit ? '0.5' : '1.0' }}
                              color="primary"
                              variant="contained"
                              onClick={() => this.onPageForward()}
                            />
                          </IconButton>
                        </div> */}
                      {isLoading ? (
                        <div className={classes.loading}>
                          <CircularProgress />
                        </div>
                      ) : (
                        <Grid
                          container
                          justifyContent="center"
                          alignContent="center"
                          style={{ height: '100%' }}
                        >
                          {appointmentRequests.length > 0 ? (
                            <Button
                              className={classes.MuiButtonText}
                              onClick={this.showMore}
                            >
                              Show More
                            </Button>
                          ) : null}
                        </Grid>
                      )}
                    </Grid>
                  )}
                </TabPanel>
              </div>
            </div>

            {openAppointmentRequestModal && (
              <AppointmentRequestViewModal
                request={requestUnderEdit}
                open={openAppointmentRequestModal}
                onClose={this.onCloseModal}
              />
            )}
          </>
        )}
      </CurrentPracticeConsumer>
    );
  }
}

ProviderAdminReferrals.contextType = CurrentUserContext;

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mainWrapper: {
    display: 'flex',
    justifyContent: 'center',
    overflow: 'scroll',
    padding: '3em',
  },
  main: {
    width: '100%',
    height: '100%',
  },
  header: {
    paddingBottom: '3em',
  },
  headerText: {
    fontWeight: 'normal',
    fontSize: '1.8em',
    lineHeight: '19px',
    color: '#1C1C1C',
  },
  actions: {
    textAlign: 'right',
  },
  pageTurners: {
    width: '100%',
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  MuiButtonText: {
    color: 'black',
  },
});

export default withSnackbar(withStyles(styles)(ProviderAdminReferrals));
